import { useEffect, useRef } from 'react';

/** Focus is presentation behavior and follows the currently mounted input. */
export const useComposerFocus = ({ focusKey, blocked }) => {
  const inputRef = useRef(null);
  const lastFocusKey = useRef('');
  const pendingFocusKey = useRef('');
  useEffect(() => {
    if (!lastFocusKey.current) { lastFocusKey.current = focusKey; return; }
    if (lastFocusKey.current !== focusKey) {
      lastFocusKey.current = focusKey;
      pendingFocusKey.current = focusKey;
    }
    if (!pendingFocusKey.current || blocked || typeof inputRef.current?.focus !== 'function') return;
    inputRef.current.focus();
    pendingFocusKey.current = '';
  }, [blocked, focusKey]);
  return inputRef;
};
